export var arrangeNodesIntoColumns = function (nodes, expandedNodeIds, hiddenLinkTypes, startNodeId, numColumns) {
    var columns = [];
    var initialColumn = [startNodeId];
    columns.push(initialColumn);
    for (var i = 1; i < numColumns; i++) {
        var nextColumn = createNextColumn(nodes, columns[i - 1], expandedNodeIds, hiddenLinkTypes);
        columns.push(nextColumn);
    }
    columns.forEach(function (column) {
        column.forEach(function (nodeId) {
            recursivelyAddParents(nodeId, column, nodes);
        });
    });
    return columns;
};
var createNextColumn = function (nodes, previousColumn, expandedNodeIds, hiddenLinkTypes) {
    var nextColumn = [];
    nodes
        .filter(function (node) { return previousColumn.includes(node.id); })
        .filter(function (node) { return expandedNodeIds.includes(node.id); })
        .map(function (node) { return node.links; })
        .map(function (nodeLinks) { return nodeLinks.filter(function (link) { return link.label === undefined || !hiddenLinkTypes.includes(link.label); }); })
        .map(function (nodeLinks) { return nodeLinks.map(function (nodeLink) { return nodeLink.nodeId; }); })
        .forEach(function (linkedNodeIds) { return addNodeIdsToColumns(linkedNodeIds, nextColumn); });
    return nextColumn;
};
var recursivelyAddParents = function (childId, column, nodes) {
    var _a;
    var parentId = (_a = nodes.find(function (node) { return node.id === childId; })) === null || _a === void 0 ? void 0 : _a.groupParentNode;
    if (parentId) {
        addNodeIdToColumn(parentId, column);
        recursivelyAddParents(parentId, column, nodes);
    }
};
var addNodeIdsToColumns = function (ids, column) {
    ids.forEach(function (id) { return addNodeIdToColumn(id, column); });
};
var addNodeIdToColumn = function (id, column) {
    if (!column.includes(id)) {
        column.push(id);
    }
};
//# sourceMappingURL=arrangeColumns.js.map